import { z } from 'zod';
import { email } from './email.js';
export const sendStudentConnectionRequestInput = z.object({ email });
export const connectionRequestInput = z.object({ requestId: z.string().min(1).max(64) });
//# sourceMappingURL=connections.js.map